export default "__VITE_ASSET__Cy62tOG___"